// ets_tracing: off
import { makeAssociative } from "@effect-ts/core/Associative";
import * as A from "@effect-ts/core/Collections/Immutable/Array";
import * as R from "@effect-ts/core/Collections/Immutable/Dictionary";
import * as NA from "@effect-ts/core/Collections/Immutable/NonEmptyArray";
import * as DSL from "@effect-ts/core/Prelude/DSL";
import * as T from "@effect-ts/core/Sync";
export const AssociativeDecodeError = /*#__PURE__*/makeAssociative((x, y) => [...x, ...y]);
export const Validation = /*#__PURE__*/DSL.getValidationF({ ...T.Applicative,
  ...T.Monad,
  ...T.Run,
  ...T.Fail
})(AssociativeDecodeError);
export const forEachNonEmptyArray = /*#__PURE__*/NA.forEachWithIndexF(Validation);
export const forEachArray = /*#__PURE__*/A.forEachWithIndexF(Validation);
export const forEachRecordWithIndex = /*#__PURE__*/R.forEachWithIndexF(Validation);
export const tuple = /*#__PURE__*/DSL.tupleF(Validation);
export const struct = /*#__PURE__*/DSL.structF(Validation);
export function mergePrefer(u, b, a) {
  const r = { ...b
  };

  for (const k of Object.keys(a)) {
    if (k in r && k in u) {
      if (u[k] !== a[k]) {
        r[k] = a[k];
      }
    } else {
      r[k] = a[k];
    }
  }

  return r;
}
export function originalSort(u, b) {
  const r = {};
  const ks = new Set(Object.keys(b));

  for (const k of Object.keys(u)) {
    if (ks.has(k)) {
      ks.delete(k);
      r[k] = b[k];
    }
  }

  ks.forEach(k => {
    r[k] = b[k];
  });
  return r;
}
export function fixKey(s) {
  if (s.startsWith(".")) {
    return s.substr(1);
  }

  return s;
}
//# sourceMappingURL=common.mjs.map